<script lang="ts">
  // `/login/continue` is the post-discovery entry; our login is a single-page,
  // progressive email-first flow, so it renders the same experience. Keeping the
  // discovery branch client-side (not in a URL) avoids any account enumeration.
  import Login from "./Login.svelte";
</script>

<Login />
